import {ContentState, convertToRaw} from 'draft-js';
import htmlToDraft from './htmlToDraftjs/library';

export const convertFromHtmlToDraftJs = (html: string): string => {
	if (!html) {
		return '';
	}

	const blocksFromHtml = htmlToDraft(html);
	const {contentBlocks, entityMap} = blocksFromHtml;
	const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);

	let draftJsContent = JSON.stringify(convertToRaw(contentState));

	// Fix the mention type to be lowercase otherwise it will not work if switching back to DraftJS
	draftJsContent = draftJsContent.replaceAll('"type":"MENTION"', '"type":"mention"');

	return draftJsContent;
};
